import { BaseSocialLoginButton } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/BaseSocialLoginButton";
import { ISocialSignOnButtonProps } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/useHandleSSOSuccess";
import { useSSOErrorStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web/common/localization";
import { logError } from "@faire/web/common/logging";
import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";
import { faireBaseUrl } from "@faire/web/common/routes/faireBaseUrl";
import React, { FC } from "react";
import { useLocation } from "react-router-dom";

const PROVIDER = SocialSignOnProvider.OKTA;

export const OktaLoginButton: FC<ISocialSignOnButtonProps> = (props) => {
  const { isOnSignIn, sourceId } = props;

  const { userClickedSSOButton, recordSSOButtonClick } = useSSOStore();

  const { errorMessage, setErrorMessage } = useSSOErrorStore();

  const { strictLocalize } = useStrictLocalization();
  const baseurl = faireBaseUrl().replace(
    /https:\/\/www\.|http:\/\/(localhost)/,
    (_, localhost) => localhost ?? ""
  );

  const isLocal = baseurl.startsWith("localhost");

  const location = useLocation();
  const queryParams = parseQueryParams(location.search);
  const redirectTo = queryParams.get("redirectTo");

  let redirectURI: string;
  if (redirectTo == null) {
    redirectURI = `${baseurl}/admin2`;
  } else {
    redirectURI = redirectTo;
  }

  const onClick = async () => {
    if (!userClickedSSOButton && errorMessage) {
      recordSSOButtonClick();
    } else {
      try {
        if (isLocal) {
          const port = baseurl.replace(/^localhost/, "");
          getWindowOrThrow().open(
            `http://localhost${port}/api/okta_sso/authorize?loginType=LOCALHOST&clientRedirectURI=${redirectURI}`,
            "_self"
          );
        } else {
          getWindowOrThrow().open(
            `https://www.${baseurl}/api/okta_sso/authorize?loginType=BROWSER&clientRedirectURI=${redirectURI}`,
            "_self"
          );
        }
        recordSSOButtonClick();
      } catch (error) {
        logError(error, {
          tags: {
            signInType: "SSO",
            provider: PROVIDER,
            code: "redirect_failed",
          },
        });
        setErrorMessage(
          strictLocalize({
            id: "eyz2Nq",
            defaultMessage: "Failed to redirect to Okta SSO.",
            description: {
              text: "Error message when failed to redirect to Okta SSO",
            },
          })
        );
      }
    }
  };

  return (
    <BaseSocialLoginButton
      onClick={onClick}
      socialProvider={PROVIDER}
      loading={false}
      isOnSignIn={isOnSignIn}
      sourceId={sourceId}
    />
  );
};
